import { getContext, setContext } from 'svelte';

export type RightPanelTab = 'sources' | 'assets';

export class RightPanelContext {
	isOpen: boolean = $state(false);
	activeTab: RightPanelTab = $state('sources');

	open(tab?: RightPanelTab) {
		this.isOpen = true;
		if (tab) {
			this.activeTab = tab;
		}
	}

	close() {
		this.isOpen = false;
	}
}

export const RIGHT_PANEL_CONTEXT_KEY = Symbol('right-panel');

export function getRightPanelContext() {
	return getContext<RightPanelContext>(RIGHT_PANEL_CONTEXT_KEY);
}

export function setRightPanelContext(ctx: RightPanelContext) {
	setContext(RIGHT_PANEL_CONTEXT_KEY, ctx);
	return ctx;
}
